import React from 'react'
import '@pages/Reports/ReportsSkeleton.css'

function ReportChartBodySkeleton(): React.ReactElement {
  return (
    <div
      className="reports-bundle-skeleton reports-chart-body-skeleton"
      aria-hidden
    >
      <div className="reports-bundle-skeleton-card reports-bundle-skeleton-shimmer">
        <span className="reports-bundle-skeleton-block" />
      </div>
    </div>
  )
}

export default ReportChartBodySkeleton
